import { render, staticRenderFns } from "./BasicAddress.vue?vue&type=template&id=6bfc68c7&functional=true&"
import script from "./BasicAddress.vue?vue&type=script&lang=js&"
export * from "./BasicAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports